import { render, staticRenderFns } from "./staffHistory.vue?vue&type=template&id=54a30abd&scoped=true"
import script from "./staffHistory.vue?vue&type=script&lang=js"
export * from "./staffHistory.vue?vue&type=script&lang=js"
import style0 from "./staffHistory.vue?vue&type=style&index=0&id=54a30abd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a30abd",
  null
  
)

export default component.exports